import { types, Instance } from 'mobx-state-tree';
import { PaymentMethodModel } from './PaymentMethodModel';
import { APIValues, UIConstants } from '../../../../utils/constants';

export const Payments = types
  .model({
    isSpreedly3DSEnabled: types.optional(types.boolean, false),
    enabledPaymentMethods: types.optional(types.array(PaymentMethodModel), []),
    isPaypalExpressAvailable: types.optional(types.boolean, false),
    pciUrl: types.optional(types.string, ''),
    pciMerchantId: types.optional(types.string, ''),
    enableStoredPaymentProfiles: types.optional(types.boolean, false),
    spreedlyEnvironmentKey: types.optional(types.string, ''),
    stripeApiVersion: types.optional(types.string, ''),
    stripeBetaVersion: types.optional(types.string, ''),
    stripePublicKey: types.optional(types.string, ''),
    stripeMerchantId: types.optional(types.maybeNull(types.string), ''),
    stripeWalletEnabled: types.optional(types.boolean, false),
    useSetupIntent: types.optional(types.boolean, false),
  })
  .views(self => ({
    get hasCardMethod(): boolean {
      return self.enabledPaymentMethods.some(
        method =>
          method.methodType === APIValues.CREDIT_CARD_METHOD ||
          method.methodType === APIValues.STRIPE_METHOD
      );
    },
    get isVpayEnabled(): boolean {
      return self.enabledPaymentMethods.some(
        method => method.methodType === APIValues.STRIPE_METHOD
      );
    },
  }))
  .actions(self => {
    const getRequired3rdPartyAction = (
      methodId: string
    ): string | undefined => {
      const paymentMethod = self.enabledPaymentMethods.find(
        method => method.id.toFixed(0) === methodId
      );
      if (paymentMethod) {
        if (paymentMethod.methodType === APIValues.PAYPAL_METHOD)
          return UIConstants.PAYPAL_CLICK_TO_CONTINUE;
        if (paymentMethod.methodType === APIValues.AMAZON_PAY_METHOD)
          return UIConstants.AMAZON_PAY_CLICK_TO_CONTINUE;
      }
      return undefined;
    };
    return {
      getRequired3rdPartyAction,
    };
  });

export interface IPayments extends Instance<typeof Payments> {}
